module.exports = __webpack_public_path__ + "media/images/favicon-1-cb0f1ee9ae0f27196a24ecfc15811a7c.ico";